// Kurzes Rütteln bei Bedienschritten.
//
// Beiwerk, nie ein Grund für einen Abbruch: jeder Fehler wird geschluckt.
// Im Browser passiert nichts — ein Capacitor-Import darf nicht einmal
// versucht werden, sonst landet er im Bündel der Website.
import { istNativ } from '../gemeinsam/lib/plattform';

export type Art = 'auswahl' | 'leicht' | 'mittel' | 'fehler';

export async function tippen(art: Art): Promise<void> {
  if (!istNativ()) return;
  try {
    const { Haptics, ImpactStyle, NotificationType } = await import('@capacitor/haptics');
    if (art === 'auswahl') await Haptics.selectionChanged();
    else if (art === 'leicht') await Haptics.impact({ style: ImpactStyle.Light });
    else if (art === 'mittel') await Haptics.impact({ style: ImpactStyle.Medium });
    else await Haptics.notification({ type: NotificationType.Error });
  } catch { /* ohne Plugin bleibt es still */ }
}
